import BaseModulePlugins from '@/store/baseModule/plugins';
import BaseModule from '@/store/baseModule';
import BaseService from '@/services/services/tools/baseService';
import BaseAPI from '@/services/api/internal/tools/baseAPI';

export default (store) => {
  store.registerModule(
    ['actionplans', 'status'],
    new BaseModule({
      serviceAPI: new BaseService({
        api: new BaseAPI({
          url: `${process.env.MYPREDITY_BASE_URI}/actionplans/status`,
        }),
        retry: { nbLeft: 3, timeout: 2000 },
      }),
    })
  );
  const basePlugin = new BaseModulePlugins({
    module: 'actionplans/status',
    store,
  });
  basePlugin.onInit(() => store.dispatch('actionplans/status/initItems'));
};
